/**
 * FormEngineChip — the small engine stamp in the top-right corner of every DDL
 * form body.
 *
 * Previously each form rendered `{engine}` raw under `uppercase`, so the chip
 * read "POSTGRES" / "MSSQL" — the internal `SqlEngine` ids, not names a user
 * recognises. `engineChipLabel` maps the id through the canonical engine
 * registry so the chip reads "PostgreSQL", "SQL Server", "MySQL", "Oracle",
 * "SQLite".
 *
 * The chip stays even though the Compact DDL popup header also names the
 * engine — these form bodies also mount outside that header (constraint
 * popovers, the Designer pane), where the chip is the only engine cue.
 *
 * Casing comes from the registry, so `uppercase` is deliberately NOT applied;
 * `tracking-wide` is kept for the same optical weight as before.
 */
import type { SqlEngine } from '../../../../sql-grammar/model';
import { engineChipLabel } from './formEngineChipHelpers';

export interface FormEngineChipProps {
  readonly engine: SqlEngine;
}

export function FormEngineChip({ engine }: FormEngineChipProps) {
  return (
    <span
      className="text-[10px] tracking-wide text-muted-foreground"
      data-testid="form-engine-chip"
    >
      {engineChipLabel(engine)}
    </span>
  );
}
